import { i as d, T as p, x as c, s as b } from "../../lit-element-6iugfgmM.js";
import { e as h } from "../../custom-element-wk-AooBb.js";
import { n as u } from "../../property-BWlAHqg_.js";
import "../../query-assigned-elements-B8U94KLQ.js";
import "../../sp-action-button-CjSKZ-qO.js";
import "@spectrum-web-components/icons-workflow/icons/sp-icon-code.js";
import "../../sp-tooltip-RAJ82M3n.js";
import { Localize as m } from "../../lib/I18N.js";
import w from "../../events/AddToWebProjectEvent.js";
const f = { "add-to-web-project-button.label": "Add to Web Project" }, v = d`@media (hover:hover){:host(:hover) sp-icon-code{color:var(--spectrum-blue-700)}}sp-icon-code{color:var(--spectrum-gray-700)}sp-action-button{min-width:0}sp-action-button:hover,sp-action-button:focus{background:transparent}`;
var j = Object.defineProperty, g = Object.getOwnPropertyDescriptor, l = (n, o, s, e) => {
  for (var a, t = e > 1 ? void 0 : e ? g(o, s) : o, i = n.length - 1; i >= 0; i--) (a = n[i]) && (t = (e ? a(o, s, t) : a(t)) || t);
  return e && t && j(o, s, t), t;
};
let r = class extends m(b, f) {
  constructor() {
    super(...arguments), this.showLabel = !1, this._renderTooltip = () => this._shouldHideTooltip() ? p : c`<sp-tooltip placement="top" self-managed>${this.t("add-to-web-project-button.label")}</sp-tooltip>`, this._handleClick = () => {
      this.dispatchEvent(new w());
    };
  }
  static get styles() {
    return v;
  }
  render() {
    return c`<sp-action-button @click="${this._handleClick}" label="${this.t("add-to-web-project-button.label")}" quiet><sp-icon-code slot="icon"></sp-icon-code>${this.showLabel ? this.t("add-to-web-project-button.label") : p} ${this._renderTooltip()}</sp-action-button>`;
  }
  _shouldHideTooltip() {
    return this.showLabel;
  }
};
l([u({ type: Boolean })], r.prototype, "showLabel", 2), r = l([h("af-add-to-web-project-button")], r);
const C = r;
export {
  C as default
};
//# sourceMappingURL=AddToWebProjectButton.js.map
